export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
};

export const notifySupported = () => "Notification" in window && "serviceWorker" in navigator;

export const requestNotify = async () => notifySupported() ? (await Notification.requestPermission()) === "granted" : false;

export const pushSignal = async (signal, symbol) => {
  if (navigator.vibrate) navigator.vibrate(signal.type === "BUY" ? [200, 100, 200] : [500, 150, 500]);
  if (!notifySupported() || Notification.permission !== "granted") return;
  const reg = await navigator.serviceWorker.ready;
  reg.showNotification(`${signal.type} ${symbol} @ ₹${signal.price.toFixed(2)}`, {
    body: `${signal.time} IST · strength ${signal.strength}% · ${signal.reason}`,
    icon: "/icon-192.png", badge: "/icon-192.png", tag: signal.id, renotify: true, requireInteraction: true,
    vibrate: signal.type === "BUY" ? [200, 100, 200] : [500, 150, 500],
  });
};
